import { Route, Routes } from "react-router-dom";
import Login from "../pages/auth/Login";
import Category from "../pages/category/Category";
import Brand from "../pages/brand/Brand";
import Product from "../pages/product/Product";
import Home from "../pages/home/Home";
import AboutUs from "../pages/static/AboutUs";
import ContactUs from "../pages/static/ContactUs";
import Faqs from "../pages/static/Faqs";
import PrivacyPolicy from "../pages/static/PrivacyPolicy";
import TermsOfUse from "../pages/static/TermsOfUse";
import Calculator from "../pages/user/Calculator";
import Profile from "../pages/user/Profile";
import SellDevice from "../pages/user/SellDevice";
import RequestConfirmation from "../pages/user/RequestConfirmation";
import ErrorPageNotFound from "../pages/errors/ErrorPageNotFound";
import SellOnline from "../pages/sell/SellOnline";
import BuyOnline from "../pages/buy/BuyOnline";
import Variant from "../pages/product/Variant";
import CityCategory from "../pages/category/CityCategory";
import CityBrand from "../pages/brand/CityBrand";
import CityProduct from "../pages/product/CityProduct";
import CityVariant from "../pages/product/CityVariant";
import {
  HOME_ROUTE,
  PRIVACY_ROUTE,
  TERMS_ROUTE,
  FAQ_ROUTE,
  CONTACT_ROUTE,
  PROFILE_ROUTE,
  LOGIN_ROUTE,
  ABOUT_ROUTE,
  REQUEST_CONFIRMATION_ROUTE,
  PAGE_NOT_FOUND_ROUTE,
  SELL_ONLINE_ROUTE,
  BUY_ONLINE_ROUTE,
  CATEGORY_ROUTE_PATTERN,
  BRAND_ROUTE_PATTERN,
  PRODUCT_ROUTE_PATTERN,
  VARIANT_ROUTE_PATTERN,
  SELL_DEVICE_ROUTE_PATTERN,
  CALCULATOR_ROUTE_PATTERN,
  CITY_CATEGORY_ROUTE_PATTERN,
  CITY_BRAND_ROUTE_PATTERN,
  CITY_PRODUCT_ROUTE_PATTERN,
  CITY_VARIANT_ROUTE_PATTERN,
} from "./constant";

export default function AppRoutes() {
  return (
    <Routes>
      {/* Home */}
      <Route path={HOME_ROUTE} element={<Home />} />

      {/* Static Pages */}
      <Route path={PRIVACY_ROUTE} element={<PrivacyPolicy />} />
      <Route path={TERMS_ROUTE} element={<TermsOfUse />} />
      <Route path={FAQ_ROUTE} element={<Faqs />} />
      <Route path={CONTACT_ROUTE} element={<ContactUs />} />
      <Route path={ABOUT_ROUTE} element={<AboutUs />} />
      <Route path={PROFILE_ROUTE} element={<Profile />} />
      <Route path={LOGIN_ROUTE} element={<Login />} />
      <Route path={SELL_ONLINE_ROUTE} element={<SellOnline />} />
      <Route path={BUY_ONLINE_ROUTE} element={<BuyOnline />} />
      <Route path={REQUEST_CONFIRMATION_ROUTE} element={<RequestConfirmation />} />

      {/* Original routes without city */}
      <Route path={CATEGORY_ROUTE_PATTERN} element={<Category />} />
      <Route path={BRAND_ROUTE_PATTERN} element={<Brand />} />
      <Route path={PRODUCT_ROUTE_PATTERN} element={<Product />} />
      <Route path={VARIANT_ROUTE_PATTERN} element={<Variant />} />
      <Route path={SELL_DEVICE_ROUTE_PATTERN} element={<SellDevice />} />
      <Route path={CALCULATOR_ROUTE_PATTERN} element={<Calculator />} />

      {/* City-based routes */}
      <Route path={CITY_CATEGORY_ROUTE_PATTERN} element={<CityCategory />} />
      <Route path={CITY_BRAND_ROUTE_PATTERN} element={<CityBrand />} />
      <Route path={CITY_PRODUCT_ROUTE_PATTERN} element={<CityProduct />} />
      <Route path={CITY_VARIANT_ROUTE_PATTERN} element={<CityVariant />} />
      {/* 404 Page */}
      <Route path={PAGE_NOT_FOUND_ROUTE} element={<ErrorPageNotFound />} />
    </Routes>
  );
}